import { Formik } from "formik";
import React, { useState } from "react";
import toast from "react-hot-toast";
import * as yup from "yup";
import { saveSubOrganizations } from "../../../../../../../api";
import TextInput from "../../../../../../components/form/text-input";
import Modal from "../../../../../../components/modal";
import Button from "../../../../../../components/new-button";
import useOrganizationStore from "../../../../../../stores/organization";
import layoutStyles from "../../../../../../styles/layout.module.scss";
import useSubOrganizations from "../../hooks/useSubOrganizations";

const schema = yup.object({
  sub_org_name: yup
    .string()
    .trim()
    .required("Sub-organization name is required"),
});

const AddSubOrganizationModal = ({ open, onClose }) => {
  const selectedOrganizationId = useOrganizationStore(
    (state) => state.selectedOrganizationData?.organization?.id,
  );
  const updateSubOrgs = useOrganizationStore((state) => state.updateSubOrgs);

  const handleAddSubOrgFormSubmit = async (values, { setSubmitting }) => {
    const postData = {
      id: null,
      sub_organization_name: values.sub_org_name,
      organization_id: selectedOrganizationId,
    };
    const toastId = toast.loading("Adding sub-organization...");
    try {
      const res = await saveSubOrganizations(postData);
      if (!res?.status) {
        console.error("Something wrong, please try again.");
        console.log(res);
      } else {
        onClose();
        toast.success("Sub-organization added successfully", {
          id: toastId,
          duration: 5000,
        });
        updateSubOrgs({
          sub_org_name: values.sub_org_name,
          user_count: 0,
        });
      }
    } catch (err) {
      if (err.status === 422) {
        toast.error("Validation error! Please fill all required fields", {
          id: toastId,
          duration: 5000,
        });
      } else {
        toast.error("Something went wrong, please try again.");
      }
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Modal
        isOpen={open}
        onClose={onClose}
        header="Add Sub-organization"
        size="sm"
      >
        <Formik
          enableReinitialize
          validationSchema={schema}
          onSubmit={handleAddSubOrgFormSubmit}
          initialValues={{
            sub_org_name: "",
          }}
          validateOnBlur={false}
        >
          {({
            handleSubmit,
            handleChange,
            values,
            touched,
            errors,
            isSubmitting,
          }) => (
            <form autoComplete="off" onSubmit={handleSubmit}>
              {console.log(values)}
              <div className={`${layoutStyles.grid} ${layoutStyles.gap2}`}>
                <div
                  className={`${layoutStyles.grid} ${layoutStyles.gridCols1} ${layoutStyles.gap2}`}
                >
                  <TextInput
                    label="Sub-organization name"
                    id="sub_org_name"
                    name="sub_org_name"
                    defaultValue={values.sub_org_name}
                    onChange={handleChange}
                    touched={touched.sub_org_name}
                    errored={errors.sub_org_name}
                    error={errors["sub_org_name"]}
                  />
                </div>
                <div className={`${layoutStyles.grid} ${layoutStyles.gap2}`}>
                  <div
                    className={`${layoutStyles.flex} ${layoutStyles.flexEnd} ${layoutStyles.gap1}`}
                  >
                    <Button type="button" variant="ghost" onClick={onClose}>
                      Cancel
                    </Button>
                    <Button type="submit" disabled={isSubmitting}>
                      Save
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default AddSubOrganizationModal;
